import { usePricesContext, Price } from '@fff-web/fff-payments';
import { IPlanCode } from '../Interfaces';
import { getSeasonalPriceWithFeatureFlag } from '../../../../gtb/src/Utilities/prices';
import { useCallback, useEffect, useState } from 'react';
import { OptimizelyDecision } from '@optimizely/react-sdk';

const getPriceByPlanCode = (prices: Price[], planCode: IPlanCode) => {
  return prices.find((plan) => plan.planCode === planCode);
};
// This hooks retrieve the prices from localization-api in fff-payment

const useGetPricesByPlan = (flag?: OptimizelyDecision) => {
  const { prices, loading } = usePricesContext();
  const [seasonalPrice, setSeasonalPrice] = useState<Price>({
    planCode: '',
    price: 0,
    annualPrice: 0,
    save: 0,
  });

  const annualPrice: Price = getPriceByPlanCode(prices, IPlanCode.ANNUAL);

  const calculateSeasonalPrice = useCallback(
    ({
      flag,
      prices,
      loading,
    }: {
      flag?: OptimizelyDecision;
      prices: Price[];
      loading: boolean;
    }) => {
      const seasonalPlan: Price = getPriceByPlanCode(
        prices,
        IPlanCode.SEASONAL
      );

      if (flag && !loading) {
        if (flag.enabled) {
          const seasonalWithFlag = getSeasonalPriceWithFeatureFlag(
            prices,
            flag,
            IPlanCode.SEASONAL
          );
          setSeasonalPrice(seasonalWithFlag);
          return;
        }
      }

      if (!loading) {
        setSeasonalPrice(seasonalPlan);
      }
    },
    [flag, prices, loading]
  );

  useEffect(() => {
    calculateSeasonalPrice({
      flag,
      prices,
      loading,
    });
  }, [flag, prices, loading]);

  return {
    annualPrice,
    seasonalPrice,
    isLoadingPrices: loading,
  };
};

export default useGetPricesByPlan;
